// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"Pagination_Pagination__11wDk","PaginationArrow":"Pagination_PaginationArrow__37UR9"};